<div [class]="'product-grid-item' + (minHeight? ' product-grid-item__min-height' : '')">
  <a
    [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
    class="cx-product-image-container"
    tabindex="-1"
  >
    <cx-media
      class="cx-product-image"
      [container]="product.images?.PRIMARY"
      format="product"
      [alt]="product.summary"
    >
    </cx-media>
  </a>

  <div class="product-details">
    <a
      [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
      class="cx-product-name"
    >
      <strong [innerHTML]="product.nameHtml"></strong>
    </a>
    <div class="cx-product-price-container">
      <div
        class="cx-product-price"
        [attr.aria-label]="'productDetails.productPrice' | cxTranslate"
      >
        {{ product.price?.formattedValue }}
      </div>
    </div>

    <div *ngIf="!hasStock" class="out-of-stock-message">
      {{ 'productGrid.outOfStock' | cxTranslate }}
    </div>


    <div class="quantity-control-box">
      <div
        class="field"
        *ngIf="!isAsturias"
        [ngClass]="{ interactive: allowEditLength, readonly: !allowEditLength }"
        >
        <label>{{ "productGrid.length" | cxTranslate }}</label>
        <ng-container>
          <input
            type="number"
            class="form-control custom-input"
            [(ngModel)]="lengthValue"
            (blur)="onLengthBlur()"
            min="350"
            max="12000"
            [readOnly]="!allowEditLength"
          />
        </ng-container>
      </div>

      <div class="field interactive" *ngIf="!isAsturias && !isPurchasedBySheet()">
        <label>{{ "productGrid.packetWeight" | cxTranslate }}</label>
        <input
          type="number"
          class="form-control custom-input"
          [(ngModel)]="weight"
          (input)="validateWeight(weight)"
          [readonly]="!allowEditWeight"
        />
        <div class="error-message" *ngIf="weightError">
          {{ weightError }}
        </div>
      </div>

      <div class="field interactive" *ngIf="!isAsturias && isPurchasedBySheet()">
        <label>{{ "productGrid.sheetsByPackage" | cxTranslate }}</label>

        <app-gonvarri-chapa-quantity
          [product]="product"
          [packageWeigth]="computedPackageWeight"
          [numberOfSheets]="numberOfSheets"
          [lenght]="lengthValue"
          (updatePackageAndSheets)="updateNumberOfSheets($event)"
          (disableAddToCart)="updateIsDisabled($event)"
          [hideTexts]="false"
          #chapaQuantityComponent
        ></app-gonvarri-chapa-quantity>

        <div class="package-weight-info">
          <small>{{ "productGrid.sheetsWeight" | cxTranslate}} {{ computedPackageWeight }}Kg</small>
        </div>
      </div>

      <div class="field interactive">
        <label>{{ "productGrid.quantity" | cxTranslate }}</label>
        <input
          type="number"
          class="form-control custom-input"
          [(ngModel)]="quantity"
          (input)="validateQuantity(quantity)"
        />
      </div>
      <label class="cantidad-label">{{
        "productGrid.quantityLabel" | cxTranslate
      }}</label>
    </div>
  </div>

  <div class="cx-add-to-cart" *ngIf="!hideAddToCartButton && isWeightValid">
    <cx-add-to-cart
      [product]="product"
      [productCode]="product.code"
      [numberOfSheets]="numberOfSheets"
      [packageWeight]="weight"
      [customQuantity]="quantity"
      [length]="lengthValue"
      [isDisabled]="false"
      [isContract]="false"
      [showQuantity]="true"
      [options]="{
        isSaveForLater: false,
        optionalBtn: false,
        displayAddToCart: true,
        addToCartString: 'addToCart.addToCart' | cxTranslate
      }"
      [showAddToCart]="!hasStock"
    ></cx-add-to-cart>
  </div>

</div>

